document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('[data-tagged-blog-posts]');
  if (!section) return;

  const cards = [...section.querySelectorAll('[data-article-card]')];
  const emptyMsg = section.querySelector('[data-empty-msg]');

  const params = new URLSearchParams(window.location.search);
  const rawTag = params.get('data') ?? '';
  const tag = decodeURIComponent(rawTag).toLowerCase().trim();

  let visibleCount = 0;
  cards.forEach((card) => {
    const cardTags = card.dataset.tags?.split('|') ?? [];
    const matches = tag ? cardTags.some((t) => t.trim() === tag) : true;
    card.classList.toggle('is-hidden', !matches);
    if (matches) visibleCount++;
  });

  if (emptyMsg) {
    emptyMsg.classList.toggle('is-hidden', visibleCount > 0);
  }
});
